<template>
  <div class="d-flex align-items-center py-4">
    <main class="form-signin w-100 m-auto">
      <form @submit.prevent="auth">
        <h1 class="h3 mb-3 fw-normal text-center">Авторизация</h1>

        <div class="form-floating">
          <input type="text" class="form-control" id="username" v-model="formData.username" placeholder="username">
          <label for="username">Логин</label>
        </div>
        <div class="form-floating mt-2">
          <input type="password" class="form-control" id="password" v-model="formData.password" placeholder="password">
          <label for="password">Пароль</label>
        </div>
        <div v-if="expired" class="alert alert-warning py-2 mt-3 mb-0 small" role="alert">Сеанс закончился, войдите заново</div>
        <div v-if="error" class="alert alert-danger py-2 mt-3 mb-0 small" role="alert">{{ error }}</div>
        <button class="btn btn-primary w-100 py-2 mt-3" type="submit" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
          Войти
        </button>
      </form>
    </main>
  </div>
</template>
<style>
.form-signin {
  max-width: 330px;
  padding: 1rem;
}
</style>
<script setup>
import {ref} from "vue";
import router from "@/router";
import {useAuthStore} from "@/store/auth";
const authStore = useAuthStore()

const formData = ref({})
const error = ref('')
const loading = ref(false)
// ?expired=1 ставит axios, когда сервер ответил 401 на истёкший токен
const expired = ref(new URLSearchParams(window.location.search).get('expired') === '1')

async function auth() {
  error.value = ''
  if (!formData.value.username || !formData.value.password) {
    error.value = 'Введите логин и пароль'
    return
  }

  loading.value = true
  try {
    const token = await authStore.auth(formData.value)
    if (!token) {
      error.value = 'Не удалось войти, попробуйте ещё раз'
      return
    }
    localStorage.setItem('token', token)
    await router.push({name: 'admin'})
  } catch (e) {
    const status = e?.response?.status
    if (status === 401) {
      error.value = 'Неверный логин или пароль'
    } else if (status === 429) {
      error.value = 'Слишком много попыток входа. Подождите минуту и попробуйте снова'
    } else if (!e?.response) {
      error.value = 'Сервер не отвечает, попробуйте позже'
    } else {
      error.value = `Ошибка входа (код ${status})`
    }
  } finally {
    loading.value = false
  }
}
</script>
